function TableBody(props) {
  const {
    children,
    ignoreHTML2Canvas,
    ...restProps
  } = props
  if (ignoreHTML2Canvas) {
    restProps['data-html2canvas-ignore'] = "true"
  }
  return (
    <tbody
      {...restProps}
    >
      {children}
    </tbody>
  )
}

export default TableBody
